/**
 * 获取年月日
 * @param {any} day 默认是1号， 传入这一个月中的某一天
 */

export function getMonthFirstDay(day = 1) {
    let year, month, days;
    year = new Date().getFullYear();
    month = new Date().getMonth() + 1;
    month = month < 10 ? '0' + month : month;
    days = day < 10 ? '0' + day : day;
    return year + '-' + month + '-' + days;
};

export function formatTime(d) {
    const date = d;
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const hour = date.getHours();
    const minute = date.getMinutes();
    const second = date.getSeconds();
    const t1 = [year, month, day].map(formatNumber).join('-');
    // const t2 = [hour, minute, second].map(formatNumber).join(':');
    return `${t1}`;
};

function formatNumber(n) {
    const str = n.toString();
    return str[1] ? str : `0${str}`;
};



// WEBPACK FOOTER //
// ./src/utils/date.js